import React from 'react';
import LinkButton from './LinkButton';
import links from './LinkLinkWithDiscordHelper';
import './LinkList.css';

const LinkList = () => {
  return (
    <div className="link-list">
      {links.map(link => (
        <LinkButton key={link.id} url={link.url} label={link.label} icon={link.icon} />
      ))}
    </div>
  );
};

export default LinkList;